/* Zabi Hair — uniforme add-to-cart feedback.
   Neemt de submit van elk product-add-formulier over (voorkomt Dawn's product-form.js
   dubbel-add via capture + stopImmediatePropagation), toont loading -> "Toegevoegd"
   en opent de winkelwagen-drawer. Werkt voor alle <button name="add">. */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ADDED_MS = 1600;
  var MIN_LOADING_MS = 500; // spinner minstens zo lang tonen (anders flitst 'ie voorbij)

  function drawer() {
    return document.querySelector('cart-drawer.zabi-drawer');
  }
  function drawerSectionId() {
    var d = drawer();
    return d ? d.getAttribute('data-section-id') : null;
  }

  function reset(btn) {
    btn.classList.remove('is-atc-loading', 'is-atc-added');
    btn.removeAttribute('aria-disabled');
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form')) return;
      var btn = form.querySelector('button[name="add"]');
      if (!btn) return; // geen add-to-cart-formulier

      // Neem de add zelf over (anders voegt Dawn's product-form.js óók toe = dubbel).
      e.preventDefault();
      e.stopImmediatePropagation();

      if (btn.classList.contains('is-atc-loading') || btn.classList.contains('is-atc-added')) return;
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

      var idInput = form.querySelector('[name="id"]');
      var id = idInput && idInput.value;
      if (!id) return;
      var qtyInput = form.querySelector('[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      btn.classList.add('is-atc-loading');
      btn.setAttribute('aria-disabled', 'true');
      var startedAt = Date.now();

      var body = { items: [{ id: parseInt(id, 10), quantity: qty }] };
      var sid = drawerSectionId();
      if (sid) {
        body.sections = sid;
        body.sections_url = window.location.pathname;
      }

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) {
          return r.json().then(function (data) {
            return { ok: r.ok, data: data };
          });
        })
        .then(function (res) {
          var wait = Math.max(0, MIN_LOADING_MS - (Date.now() - startedAt));
          setTimeout(function () {
            btn.classList.remove('is-atc-loading');
            if (!res.ok || (res.data && res.data.status && res.data.status !== 200)) {
              // bv. niet op voorraad: terug naar normaal, geen valse succes-state
              btn.removeAttribute('aria-disabled');
              return;
            }
            btn.classList.add('is-atc-added');
            // Drawer verse HTML geven + openen (drawer.refresh haalt zelf de sectie op).
            document.dispatchEvent(new CustomEvent('zabi:cart:open'));
            setTimeout(function () {
              reset(btn);
            }, ADDED_MS);
          }, wait);
        })
        .catch(function () {
          reset(btn);
        });
    },
    true // capture: vóór Dawn's form-submit-listener
  );
})();
